export default "__VITE_ASSET__BbyUsv9z__"